<template>
    <div class="bg-white">
        <Head>
            <title>{{ point.name }} - {{ lake.name }}</title>
        </Head>
        <Header :pageName="lake.name" :cartCount="cartCount"/>
        <div class="mx-auto max-w-2xl px-4 py-4 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8 relative">
            <div class="grid grid-flow-row-dense grid-cols-3 points-main-wrapper">
                <div class="col-span-2 mr-10 points-items">
                    <div class="flex mb-4 justify-between">
                        <h2 class="page-title">
                            <Link class="text-sky-600" :href="`/lake/${lake.id}`">{{ lake.name }} /&nbsp;</Link> {{ point.name }}
                        </h2>
                        <div>
                            <ul class="flex flex-column justify-start mt-3 lg:justify-end">
                                <li class="py-0 text-sm font-bold">Наявний час:</li>
                                <li v-for="type in types" class="py-0 ml-6"
                                    :class="type.icon"/>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <img :src="`/storage/${point.images}`" class="w-full" :alt="point.name"/>
                    </div>
                    <div class="my-4 leading-5 visible-xl" v-html="point.description"/>
                </div>
                <div class="points-calendar">
                    <h3 class="text-3xl">Параметри бронювання</h3>
                    <div class="my-4 text-2xl">дата: {{ selectedDate }}</div>
                    <div class="my-4 text-2xl">ціна: {{ price }} грн</div>
                    <Calendar
                        :calendarData="calendarData"
                        :currentDateData="currentDateData"
                        :default-disabled-days="disabledDays"
                        :default-day="calendarDate"
                        @selectDate="changeDate"
                        @setDate="setMonth"
                    />
                    <form @submit.prevent="addToCart">
                        <div class="flex mt-4">
                            <text-input
                                v-if="isQuantityAvailable"
                                v-model="form.quantity"
                                :error="form.errors.quantity"
                                class="pb-8 w-full"
                                type="number"
                                min="1"
                                label="Кількість людей"
                            />
                        </div>
                        <div class="flex mt-4">
                            <select-input
                                v-model="form.typeId"
                                :error="form.errors.typeId"
                                class="pb-8 w-full"
                                label="Тип рибалки"
                            >
                                <option v-for="type in types" :key="type.id" :value="type.id">
                                    {{ type.name }} ({{ type.description }})
                                </option>
                            </select-input>
                        </div>
                        <div class="flex">
                            <select-input
                                v-model="form.categoryId"
                                :error="form.errors.categoryId"
                                class="pb-8 w-full"
                                label="Тариф"
                            >
                                <option v-for="category in categories" :key="category.id" :value="category.id">
                                    {{ category.name }}
                                </option>
                            </select-input>
                        </div>
                        <div class="mb-4" v-if="point.attributes.length">
                            Додатково:
                            <ul class="mt-2">
                                <li class="flex items-center mb-1" v-for="attribute in point.attributes">
                                    <input
                                        class="mr-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                        :checked="!attribute.optional"
                                        :disabled="!attribute.optional"
                                        type="checkbox"
                                        :id="'checkbox-' + attribute.id"
                                        v-model="attribute.checked"
                                        @click="selectAttribute(attribute.id)"
                                    >
                                    <label :for="'checkbox-' + attribute.id">
                                        {{ attribute.title }} - {{ attribute.price }} грн
                                    </label>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <loading-button
                                class="h-12 btn-indigo uppercase tracking-widest btn-booking text-uppercase rounded-lg justify-center"
                                :loading="form.processing"
                            >
                                Забронювати
                            </loading-button>
                        </div>
                    </form>
                    <div class="my-4 leading-5 visible-sm" v-html="point.description"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Header from "@/Component/Header"
import LoadingButton from "@/Shared/LoadingButton"
import Calendar from "@/Component/Calendar"
import PointsBookingModal from "@/Component/PointsBookingModal"
import messages from "@/Constants/messages"
import {useToast} from "vue-toastify"
import SelectInput from "@/Shared/SelectInput"
import TextInput from "@/Shared/TextInput.vue";
import axios from "axios";

export default {
    components: {
        Link,
        TextInput,
        SelectInput,
        PointsBookingModal,
        LoadingButton,
        Header,
        Head,
        Calendar,
    },
    props: {
        types: Object || Array,
        categories: Array,
        lake: Object,
        point: Object,
        disabledDays: Object,
        calendarData: Object,
        selectedDate: String,
        filters: Object,
        currentDateData: Object,
        cartCount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                date: [this.selectedDate, this.selectedDate],
                month: this.filters.month,
                year: this.filters.year,
                quantity: 1,
                lakeId: this.point.lake_id,
                typeId: this.types[0] ? this.types[0].id : null,
                categoryId: this.categories[0] ? this.categories[0].id : null,
                pointId: this.point.id,
                attributesIds: [],
                is_point: true
            }),
            cartItemsCount: this.cartCount,
            price: this.point.price
        };
    },
    computed: {
        isQuantityAvailable() {
            if (!this.lake.price_depend_on_people_count) {
                this.form.quantity = 0
            }
            return !!this.lake.price_depend_on_people_count
        },
        calendarDate() {
            if (Array.isArray(this.form.date)) {
                return this.form.date[0];
            }
            return this.form.date;
        }
    },
    watch: {
        form: {
            handler: function () {
                this.fetchPriceDays();
            },
            deep: true
        },
    },
    methods: {
        getPoint() {
            this.$inertia.get(
                this.$route('index.point.view', {
                    'lake': this.lake.id,
                    'point': this.point.id,
                    'date': this.form.date,
                    'month': this.form.month,
                    'year': this.form.year
                })
            );
        },
        changeDate(date) {
            this.form.date = date;
            this.getPoint()
        },
        setMonth(dateData) {
            this.form.month = dateData.month
            this.form.year = dateData.year
            this.form.date = `${dateData.year}-${dateData.month}-1`
            this.getPoint()
        },
        addToCart() {
            this.form.post(this.$route('cart.add.without.redirect', this.form.pointId), {
                preserveScroll: true,
                onSuccess: (page) => {
                    this.showToast(messages.successAddedToCart)
                    this.$inertia.get(this.$route('index.cart'))
                },
                onError: (errors) => {
                    const msg = Object.values(errors)[0] || 'Помилка під час додавання'
                    this.showToast(msg, 'error')
                },
            });
        },
        showToast(message, type='success') {
            if (type === 'error') {
                return  this.toast.error(message)
            }
            this.toast.success(message);
        },
        fetchPriceDays() {
            if (this.point.id) {
                axios.get(`/current-price/${this.point.id}`, {
                    params: {
                        quantity: this.form.quantity,
                        lakeId: this.form.lakeId,
                        date: this.form.date,
                        typeId: this.form.typeId,
                        categoryId: this.form.categoryId,
                        pointId: this.form.pointId,
                        attributesIds: this.form.attributesIds,
                    }
                })
                    .then(response => {
                        this.price = response.data.price;
                    })
                    .catch(error => {
                        console.error('Error fetching price:', error);
                    });
            }
        },
        selectAttribute(id) {
            const index = this.form.attributesIds.indexOf(id)
            if (index !== -1) {
                this.form.attributesIds.splice(index, 1)
            } else {
                this.form.attributesIds.push(id)
            }
        }
    },
    mounted() {
        this.toast = useToast()
    }
}
</script>
<style scoped>
.visible-sm {
    display: none;
}
.visible-xl {
    display: block;
}
@media only screen and (max-width: 1024px) {
    .visible-sm {
        display: block;
    }
    .visible-xl {
        display: none;
    }
    .points-main-wrapper .points-items {
        order: 1;
        margin-right: 0
    }

    .points-calendar {
        order: 2;
    }
}
</style>
